import React, { CSSProperties, SyntheticEvent, useState } from "react";

import { Button, Form, Input, Segment } from "semantic-ui-react";

import { useIntl } from "react-intl";

type SpecifyEmailLoginProps = {
  onEmailSubmit: (email: string) => Promise<void>;
};

type Styles = Record<
  "body" | "container" | "errorMessage" | "iconContainer" | "iconWrapper" | "label" | "segment",
  CSSProperties
>;

const styles: Styles = {
  container: {
    margin: "0 auto",
    maxWidth: "500px",
    width: "100%",
  },
  errorMessage: {
    alignItems: "center",
    backgroundColor: "#fff1f0",
    border: "1px solid #ffccc7",
    borderRadius: "8px",
    color: "#cf1322",
    display: "flex",
    fontSize: "13px",
    marginTop: "8px",
    padding: "12px 16px",
  },
  iconContainer: {
    marginBottom: "40px",
    textAlign: "center",
  },
  iconWrapper: {
    display: "inline-block",
  },
  label: {
    color: "rgba(43, 43, 43, 1)",
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "12px",
  },
  segment: {
    borderRadius: "25px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
    padding: "50px 40px",
  },
  body: {
    alignItems: "center",
    background: "rgba(243, 130, 160, 0.53)",
    display: "flex",
    justifyContent: "center",
    minHeight: "100vh",
  },
};

const IMAGES = {
  emailLogin: "/static/images/landing/email-login.png",
};

const SpecifyEmailLogin = (props: SpecifyEmailLoginProps) => {
  const intl = useIntl();

  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState<string>("");

  const handleSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      await props.onEmailSubmit(email);
    } catch (error: any) {
      setEmailError(JSON.stringify(error.message?.override_email?.[0] || error.message));
    }

    setIsLoading(false);
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <Segment style={styles.segment}>
          <div style={styles.iconContainer}>
            <div style={styles.iconWrapper}>
              <img style={{ width: "300px" }} src={IMAGES.emailLogin} />
            </div>
          </div>

          <Form onSubmit={handleSubmit}>
            <Form.Field required>
              <label style={styles.label}>กรุณาระบุอีเมล์</label>
              <Input
                ref={(ref: any) => {
                  if (ref) {
                    ref.inputRef.current.style.borderRadius = "8px";
                  }
                }}
                placeholder="example@mail.com"
                type="email"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
              />

              {!!emailError && (
                <div style={styles.errorMessage}>
                  <span style={{ marginRight: "8px" }}>⚠</span>
                  <span>
                    {emailError.search(new RegExp(`Duplicate entry.*${email}.*email`)) >= 0
                      ? intl.formatMessage({ id: "ชื่อผู้ใช้นี้มีผู้อื่นใช้แล้ว ลองใช้ชื่ออื่น" })
                      : emailError}
                  </span>
                </div>
              )}
            </Form.Field>

            <div style={{ display: "flex", justifyContent: "center", marginTop: "3rem" }}>
              <Button
                style={{
                  backgroundColor: "var(--primary-theme-color)",
                  borderRadius: "28px",
                  color: "white",
                  fontSize: "15px",
                  width: "68%",
                }}
                loading={isLoading}
                size="large"
                fluid
                onClick={handleSubmit}
              >
                ถัดไป
              </Button>
            </div>
          </Form>
        </Segment>
      </div>
    </div>
  );
};

export default SpecifyEmailLogin;
